import illustration from "./assets/under-construction.png";

export interface ShowViewProps {
  title: string;
  description: string;
}

export function ShowView({ title, description }: ShowViewProps) {
  return (
    <div className="flex flex-col items-center">
      <img
        alt=""
        className="-ml-[29px] h-[163px] w-[280px] object-contain md:-ml-[64px] md:h-[360px] md:w-[620px]"
        src={illustration}
      />
      <div className="flex flex-col items-center gap-2 px-4 pt-6 text-center md:px-0 md:pt-5">
        <h1 className="text-display-xs font-extrabold tracking-display-xs text-green-950 md:text-display-xl md:tracking-display-xl">
          {title}
        </h1>
        <p className="text-base tracking-base text-neutral-800 md:text-2xl md:tracking-2xl">{description}</p>
      </div>
    </div>
  );
}
